<admin-header [primaryButtons]="headerPrimaryButtons" [secondaryButtons]="headerSecondaryButtons" [tertiaryButtons]="headerTertiaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div class="row" id="filters">
	<div class="col-12">
		<dx-button (onClick)="viewToday()" style="float: right !important;"><i class="fal fa-calendar-check"></i> Today</dx-button>
		<dx-date-box [value]="opsPlanningDate" label="Date" id="opsPlanningDate" stylingMode="filled" labelMode="hidden" displayFormat="dd/MM/yyyy" [min]="minDate" (onValueChanged)="changeOpsPlanningDate($event)" style="float: right !important; width: 200px;"></dx-date-box>
		<dx-select-box [value]="opsPlanningMode" id="opsPlanningMode" [dataSource]="opsPlanningModes" displayExpr="name" placeholder="Mode" valueExpr="id" [showClearButton]="false" (onValueChanged)="changeOpsPlanningMode($event)" style="float: right !important; width: 200px;"></dx-select-box>
	</div>
</div>
<div class="row">
	<div *ngIf="machines.length === 0" id="loadingBar"><i class="fad fa-sync-alt fa-spin"></i> Loading...</div>
	<div *ngFor="let machine of machines" class="col-12 machineInfo">
		<h2 style="background-color: {{machine.siteColour}};"><i class="fa fa-dot-circle" style="margin-right:20px; color:{{this.renderStatusColor(machine.productionStatus)}};"></i>{{machine.cellNumber}} <a *ngIf="machine.machineId !== undefined && machine.machineId > 0" href="#" style="color:rgb(213, 213, 213)" (click)="changeMachineProductionStatusPopup(machine.machineId)">- {{machine.productionStatusName}}</a></h2>
		<p><strong>{{machine.machineName}}</strong> in <strong>{{machine.department}}</strong><span *ngIf="machine.showAvailability === true">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fal fa-sun"></i> {{machine.dayShiftDescription}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fal fa-moon"></i> {{machine.nightShiftDescription}} <strong *ngIf="machine.availabilityOverridden === true">(Overridden)</strong></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <i class="fal fa-recycle"></i> {{machine.scrappedParts}}</p>
		<table *ngIf="showRunningSections() === true">
			<tbody>
				<tr>
					<th class="running" colspan="18">Running</th>
				</tr>
				<tr>
					<th scope="col">W/O</th>
					<th scope="col">Date Req.</th>
					<th scope="col">Part</th>
					<th scope="col">OP</th>
					<th scope="col">QReq.</th>
					<th scope="col">QComp.</th>
					<th scope="col">Operator</th>
					<th scope="col">Remaining</th>
					<th scope="col">End Time</th>
					<th scope="col">Last Est.</th>
					<th></th>
					<th></th>
					<th><i class="fal fa-calendar-alt" title="Estimated Shifts"></i></th>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
					<th><i class="fal fa-recycle"></i></th>
				</tr>
				<tr *ngIf="machine.runningStages.length === 0" style="height:30px !important;">
					<td colspan="18" style="padding:20px !important;color:lightcoral"><strong>Nothing Running...</strong></td>
				</tr>
				<tr *ngFor="let workOrderStage of machine.runningStages" [class]="workOrderStage.topFive === true || machinesShowingAllRunning.indexOf(machine.machineId) >= 0 ? '' : 'hidden'" style="border-top: dashed rgb(187, 187, 187) 2px;">
					<th scope="row" [class]="workOrderStage.isPaused ? 'paused' : ''"><i *ngIf="workOrderStage.isPaused" class="fa-pause-circle fal me-2"></i><a href="/admin/workOrders/{{workOrderStage.workOrderId}}">{{workOrderStage.workOrderId}}</a></th>
					<td>{{renderDateString(workOrderStage.dateRequired)}}</td>
					<td id="runningPartNumber{{workOrderStage.id}}">{{workOrderStage.partNumber}}								
						<dx-tooltip target="#runningPartNumber{{workOrderStage.id}}" showEvent="mouseenter" hideEvent="mouseleave" position="right">
							<div *dxTemplate="let data = data; of: 'content'">
								<img alt="{{workOrderStage.partNumber}}" width="300" src="{{workOrderStage.partImage}}" />
							</div>
						</dx-tooltip>
					</td>
					<td>{{workOrderStage.operationNumber}}</td>
					<td>{{workOrderStage.quantityRequired}}</td>
					<td>{{workOrderStage.quantityCompleted}}</td>
					<td>{{workOrderStage.assignedUserProfileFullName}}</td>
					<td>{{workOrderStage.estimatedRunTimeDescription}}</td>
					<td>{{workOrderStage.estimatedEndTimeDescription}}</td>
					<td>{{workOrderStage.lastEstimatedAtDescription}} <a href="#" *ngIf="machine.machineId" (click)="recalculateStageEstimates(workOrderStage.id)"><i class="fal fa-stopwatch"></i></a></td>
					<td><a href="#" *ngIf="machine.machineId > 0" (click)="changeWorkOrderStageOperatorPopup(workOrderStage.id, machine.machineId, true)"><i class="fal fa-user-edit"></i></a></td>
					<td><a href="#" *ngIf="machine.machineId > 0 && workOrderStage.operatorQueue.length > 5" (click)="assignNextOperatorInQueue(workOrderStage.id)"><i class="fal fa-user-check"></i></a></td>
					<td>{{workOrderStage.estimatedShifts}}</td>
					<td colspan="4">
						<div class="row">
							<div class="col-12" style="padding:5px; color:#ffffff;">
								<div style="width:100%; height:25px; background-color: #2B2B38; border-radius:25px">
									<div style="width:{{workOrderStage.quantityCompleted/workOrderStage.quantityRequired * 100}}%; height:25px; background-color:#33aa00; padding-left:20px; padding-top:3px; border-radius:25px">{{(workOrderStage.quantityCompleted/workOrderStage.quantityRequired * 100).toFixed(0)}}%</div>
								</div>
							</div>
						</div>
					</td>
					<td>{{workOrderStage.scrappedParts}}</td>
				</tr>
				<tr *ngIf="machine.runningStages.length > 5">
					<th colspan="18"><a href="#" (click)="toggleMachineShowingAllRunning(machine.machineId)">Show {{(machinesShowingAllRunning.indexOf(machine.machineId) >= 0 ? 'Less' : 'All')}}</a></th>
				</tr>
			</tbody>
		</table>
		<table>
			<tbody>
				<tr style="border-top: solid black 2px;">
					<th class="available" colspan="19">Available &amp; Pending</th>
				</tr>
				<tr>
					<th scope="col">W/O</th>
					<th scope="col">Date Req.</th>
					<th scope="col">Part</th>
					<th scope="col">OP</th>
					<th scope="col">QReq.</th>
					<th scope="col">QComp.</th>
					<th scope="col">Operator</th>
					<th scope="col">E.Start Time</th>
					<th scope="col">Run Time</th>
					<th scope="col">End Time</th>
					<th></th>
					<th><i class="fal fa-calendar-alt" title="Estimated Shifts"></i></th>
					<th scope="col">Priority</th>
					<th scope="col">Move</th>
					<th scope="col">E.Start Date</th>
					<th></th>
					<th scope="col">E.Time</th>
					<th></th>
					<th><i class="fal fa-recycle"></i></th>
				</tr>
				<tr *ngIf="machine.availableStages.length === 0" style="height:30px !important;">
					<td colspan="19" style="padding:20px !important;color:lightcoral"><strong>Nothing Available...</strong></td>
				</tr>
				<tr *ngFor="let workOrderStage of machine.availableStages" [class]="workOrderStage.topFive === true || machinesShowingAllAvailable.indexOf(machine.machineId) >= 0 ? '' : 'hidden'" [style]="workOrderStage.showDivider ? 'border-top: 2px dotted #ff9900;' : 'border-top: 2px dashed rgb(187, 187, 187);'">
					<th scope="row" [class]="workOrderStage.isPaused ? 'paused' : ''">
						<i *ngIf="workOrderStage.isPaused === true" class="fa-pause-circle fal me-2"></i>
						<i *ngIf="workOrderStage.isPaused === false && workOrderStage.isPending === true" class="fa-stop-circle fas me-2 pending" title="Pending"></i>
						<i *ngIf="workOrderStage.isPaused === false && workOrderStage.isPending === false" class="fa-dot-circle fas me-2 available"></i>
						<a href="/admin/workOrders/{{workOrderStage.workOrderId}}">{{workOrderStage.workOrderId}}</a></th>
					<td>{{renderDateString(workOrderStage.dateRequired)}}</td>
					<td id="availablePartNumber{{workOrderStage.id}}">{{workOrderStage.partNumber}}
						<dx-tooltip target="#availablePartNumber{{workOrderStage.id}}" showEvent="mouseenter" hideEvent="mouseleave" position="right">
							<div *dxTemplate="let data = data; of: 'content'">
								<img alt="{{workOrderStage.partNumber}}" width="300" src="{{workOrderStage.partImage}}" />
							</div>
						</dx-tooltip>
					</td>
					<td>{{workOrderStage.operationNumber}}</td>
					<td>{{workOrderStage.quantityRequired}}</td>
					<td>{{workOrderStage.quantityComplete}}</td>
					<td>{{workOrderStage.assignedUserProfileFullName}}</td>
					<td>{{workOrderStage.estimatedStartTimeDescription}} <i *ngIf="workOrderStage.estimatedStartTimeIcon !== ''" class="fal fa-{{workOrderStage.estimatedStartTimeIcon}}"></i></td>
					<td>{{workOrderStage.estimatedRunTimeDescription}}</td>
					<td>{{workOrderStage.estimatedEndTimeDescription}}</td>
					<td><a href="#" *ngIf="machine.machineId > 0" (click)="changeWorkOrderStageOperatorPopup(workOrderStage.id, machine.machineId, false)"><i class="fal fa-user-edit"></i></a></td>
					<td>{{workOrderStage.estimatedShifts}}</td>
					<td>
						<dx-select-box *ngIf="workOrderStage.desiredStartTime === null" [dataSource]="priorities" [value]="workOrderStage.priority" [showClearButton]="false" (onValueChanged)="changeWorkOrderStagePriorityDropDown($event, workOrderStage.id)"></dx-select-box>
						<span *ngIf="workOrderStage.desiredStartTime !== null">{{workOrderStage.priority}}</span>
					</td>
					<td><a href="#" (click)="changeWorkOrderStageMachinePopup(workOrderStage.id)"><i class="fal fa-arrows-alt"></i></a></td>
					<td>{{workOrderStage.estimatedStartDate}}</td>
					<td><a href="#" (click)="changeWorkOrderStageEstimatedStartDatePopup(workOrderStage.id)"><i class="fal fa-calendar-edit"></i></a></td>
					<td>{{workOrderStage.desiredStartTime}}</td>
					<td><a href="#" (click)="changeWorkOrderStageDesiredStartTimePopup(workOrderStage.id)"><i class="fal fa-clock"></i></a></td>
					<td>{{workOrderStage.scrappedParts}}</td>
				</tr>
				<tr *ngIf="machine.availableStages.length > 5">
					<th colspan="19"><a href="#" (click)="toggleMachineShowingAllAvailable(machine.machineId)">Show {{(machinesShowingAllAvailable.indexOf(machine.machineId) >= 0 ? 'Less' : 'All')}}</a></th>
				</tr>
			</tbody>
		</table>
	</div>
</div>
<dx-popup [width]="750" [height]="500" [showTitle]="true" [title]="popupTitle" [dragEnabled]="false" [closeOnOutsideClick]="false" [showCloseButton]="false" container=".dx-viewport" [(visible)]="popupVisible">
	<dxi-toolbar-item widget="dxButton" toolbar="bottom" location="before" [options]="popupAddButtonOptions"></dxi-toolbar-item>
	<dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="popupCloseButtonOptions"></dxi-toolbar-item>
	<dx-form *ngIf="popupTitle === 'Change Desired Start Time'" class="m-3" [(formData)]="popupChangeWorkOrderStageDesiredStartTime" [showColonAfterLabel]="true" labelLocation="top">
		<dxi-item><p>You must enter a valid time in HH:mm format, e.g. 09:30.</p></dxi-item>
		<dxi-item dataField="startTime"></dxi-item>
	</dx-form>
	<dx-form *ngIf="popupTitle === 'Change Estimated Start Date'" class="m-3" [(formData)]="popupChangeWorkOrderStageEstimatedStartDate" [showColonAfterLabel]="true" labelLocation="top">
		<dxi-item><p>Please note that this will revert if the estimates on this work order are recalculated.</p><p>Future stages of this work order will also be changed relative to this.</p></dxi-item>
		<dxi-item dataField="estimatedStartDate" editorType="dxDateBox" [editorOptions]="{ displayFormat: 'dd/MM/yyyy', type: 'date' }"></dxi-item>
	</dx-form>
	<dx-form *ngIf="popupTitle === 'Change Machine'" class="m-3" [(formData)]="popupChangeWorkOrderStageMachine" [showColonAfterLabel]="true" labelLocation="top">
		<dxi-item dataField="machineId" editorType="dxSelectBox" [editorOptions]="{ items: machines, searchEnabled: true, displayExpr: displayMachineInDropdown, valueExpr:'machineId' }" [label]="{ text: 'Machine' }"></dxi-item>
	</dx-form>
	<dx-form *ngIf="popupTitle === 'Change Operators'" class="m-3" [(formData)]="popupChangeWorkOrderStageOperator" [showColonAfterLabel]="true" labelLocation="top" [colCount]="2">
		<dxi-item dataField="userProfileId" editorType="dxSelectBox" [editorOptions]="{ items: dropdownUserProfiles, searchEnabled: true, displayExpr: displayUserProfileInDropdown, valueExpr:'id' }" [label]="{ text: 'Operator' }"></dxi-item>
		<dxi-item><p>Estimated Shifts: {{popupEstimatedShifts}}</p></dxi-item>
		<dxi-item itemType="group" [colSpan]="2">
			<dx-data-grid class="data-grid" [dataSource]="popupOperatorQueue" [remoteOperations]="false" [allowColumnReordering]="false" [allowColumnResizing]="false" [rowAlternationEnabled]="true" [showBorders]="true" height="200px">
				<dxo-paging [pageSize]="100"></dxo-paging>
				<dxo-pager [visible]="false" [showPageSizeSelector]="false" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
				<dxo-search-panel [visible]="false" [highlightCaseSensitive]="true"></dxo-search-panel>
				<dxo-group-panel [visible]="false"></dxo-group-panel>
				<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
				<dxo-export [enabled]="false"></dxo-export>
				<dxo-row-dragging [allowReordering]="true" [onReorder]="updatePopupOperatorQueueOrder" [showDragIcons]="true"></dxo-row-dragging>
				<dxo-editing mode="popup" [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true" [confirmDelete]="true" [useIcons]="true" newRowPosition="last" [changes]="changes" [(editRowKey)]="editRowKey">
				<dxo-popup title="Select Operator" [showTitle]="true" [width]="'50%'" [height]="'auto'"></dxo-popup>
				<dxo-form [colCount]="1">
					<dxi-item dataField="operatorId" editorType="dxSelectBox" [editorOptions]="{ items: dropdownUserProfiles, searchEnabled: true, displayExpr: displayUserProfileInDropdown, valueExpr:'id' }" [label]="{ text: 'Operator' }"></dxi-item>
				</dxo-form>
				</dxo-editing>
				<dxo-toolbar>
					<dxi-item name="addRowButton" showText="always"></dxi-item>
				</dxo-toolbar>
				<dxi-column dataField="operatorId" dataType="number" alignment="left" caption="Operator">
					<dxo-lookup [dataSource]="userProfiles" [displayExpr]="displayUserProfileInDropdown" valueExpr="id"></dxo-lookup>
				</dxi-column>
				<dxi-column type="buttons">
					<dxi-button name="edit"></dxi-button>
					<dxi-button name="delete"></dxi-button>
				</dxi-column>
			</dx-data-grid>
		</dxi-item>
	</dx-form>
	<dx-form *ngIf="popupTitle === 'Change Production Status'" class="m-3" [(formData)]="popupChangeMachineProductionStatus" [showColonAfterLabel]="true" labelLocation="top">
		<dxi-item dataField="productionStatus" editorType="dxSelectBox" [editorOptions]="{ items: productionStatuses, searchEnabled: true, displayExpr:'name', valueExpr:'id' }" [label]="{ text: 'Production Status' }"></dxi-item>
	</dx-form>
</dx-popup>